// import "./index.scss"

import React from "react";
import { Input, Button, Icon, Row, Col, Form } from "antd";
import { login } from "../../apis/apis";
import { _APP } from './../../apis/apis';
import { Link } from 'react-router-dom';

class Login extends React.Component {
    // componentDidMount(){
    //     console.log("login PAGE OPEN")
    // }
    // componentWillUnmount(){
    //     console.log("login PAGE CLOSE")
    // }
    state = {
        msg: "",
        username: "",
        password: "",
        verify: "",
        verifySrc: _APP + "/rest/verifyCode/getCode?_=" + Math.random()
    }
    refresh = (e) => {
        this.setState({
            verifySrc: _APP + "/rest/verifyCode/getCode?_=" + Math.random()
        })
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    loading: true
                });
                this.setState({
                    loading: true
                })
                login(values.name, values.password, values.captcha).then((response) => {
                    this.setState({
                        loading: false
                    })
                    let data = response.data;
                    // let uid = data.uid
                    // let storage = window.localStorage
                    // storage.setItem("uid", uid);
                    // //判断是否为预付款用户
                    // if(data.prepayUser === "1"){
                    //     storage.setItem("isPreParePay" , 1)
                    // }else if(data.prepayUser !== "1"){
                    //     storage.setItem("isPreParePay" , 0)
                    // }
                    if (data.success) {
                        this.setState({
                            msg: "登录成功"
                        })
                        window.location.href = "index.html";
                    } else {
                        this.setState({
                            msg: data.exception
                        })
                    }
                }).catch((error) => {
                    let data = error.response.data;
                    this.setState({
                        msg: data.exception,
                        loading: false
                    })
                });
            }
        })
    }
    loginPSW = (rule, value, callback) => {
        console.log('loginPSW');
        console.log(value);
        callback();
    }
    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const { getFieldDecorator } = this.props.form;
        return (
            <Form id="login" onSubmit={this.handleSubmit}>
                <Form.Item>
                    {getFieldDecorator('name', {
                        rules: [{ required: true, message: '请输入用户名' },
                            // {
                            //     pattern: /^(?!_)[a-zA-Z0-9_\u4e00-\u9fa5]{6,12}$/, message: "用户名为6-12个字符,只能为汉字、数字、字母、下划线"
                            // }
                        ],
                    })(
                        <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="用户名、手机号" />
                    )}
                </Form.Item>
                <Form.Item >
                    {getFieldDecorator('password', {
                        rules: [{
                            required: true, message: '请输入密码!',
                        },
                        // {
                        //     validator: this.loginPSW,
                        // }
                            //{ pattern: /^[A-Za-z0-9]{6,16}$/, message: "密码只能包含数字、字母、下划线" },
                            // {
                            //     pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,}$/,
                            //     message: "密码最少6位，包括至少1个大写字母，1个小写字母，1个数字"
                            // }
                        ]
                    })(
                        <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="密码" />
                    )}
                </Form.Item>
                <Form.Item>
                    <Row gutter={8}>
                        <Col span={12}>
                            {getFieldDecorator('captcha', {
                                rules: [{ required: true, message: '请输入右侧验证码' }],
                            })(
                                <Input placeholder="请输入右侧验证码" />
                            )}
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <img ref="verify" src={this.state.verifySrc} alt={"点击刷新"} onClick={(e) => this.refresh(e)} />
                        </Col>
                    </Row>
                </Form.Item>
                <Row>
                    <Col> <Link to="/register" >注册</Link> <Link to="/forget" style={{ float: "right" }}>忘记密码</Link></Col>
                </Row>
                <Form.Item>
                    <Button style={{ marginTop: "10px" }} type="primary" htmlType="submit" size="large" block>登录{this.state.loading ? <Icon type="loading" /> : null}</Button>
                </Form.Item>
                <Row><Col> <div className="msg">{this.state.msg}</div></Col></Row>
            </Form >
        );
    }
}

export default Form.create({ name: "login" })(Login);